var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRightTool2Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_2540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 5.8125V18.1875",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81238 3.0625H18.8749",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 18.1875V5.8125",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1874 20.9375H5.81238",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.125 1H1V5.125H5.125V1Z",
    fill: "#70C2EA",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.125 18.875H1V23H5.125V18.875Z",
    fill: "#70C2EA",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1H18.875V5.125H23V1Z",
    fill: "#70C2EA",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 18.875H18.875V23H23V18.875Z",
    fill: "#70C2EA",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_2540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightTool2Active);
export default __webpack_public_path__ + "static/media/ico-right-tool-2-active.8c22c2691235074bc9b21e64bba64c1f.svg";
export { ForwardRef as ReactComponent };